export const environment = {
	production: false,
	showLogs: true,
	hotjar: { hjid: 5302844, hjsv: 6 },
	api: 'https://api-appcrypto-qa.towerbank.com',
	configToken: 'MmI3ZTE1MTYyOGFlZDJhNmFiZjcxNTg4MDljZjRmMmM=',
	TOKEN_URL: 'e35d51b9c6e9fd076963d5bf7b980cbd4db8721fbbe3791cf8649ee5d111d2a0',
	wafUrl: 'https://49a62215f0d7.edge.sdk.awswaf.com/49a62215f0d7/704348a9dbaf/challenge.js'
};
console.log('Development environment loaded');